import {Component, OnDestroy, OnInit} from '@angular/core';
import {BroadcastingsService} from "../../../services/broadcastings-services/broadcastings.service";
import {tap} from "rxjs/internal/operators/tap";
import {Subscription} from "rxjs";
import {Breadcrumb} from "../../../models/breadcrumb-models/breadcrumb-model/breadcrumb.model";
import {HeaderBreadcrumbService} from "../../header-components/header-breadcrumb/header-breadcrumb.service";
import {BRoute} from "../../../models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model";

@Component({
  selector: 'app-broadcastings-config-dashboard',
  templateUrl: './broadcastings-config-dashboard.component.html',
  styleUrls: ['./broadcastings-config-dashboard.component.scss']
})
export class BroadcastingsConfigDashboardComponent implements OnInit, OnDestroy {

  config;
  getBroadcastingsConfigSubscription: Subscription;
  refreshConfigSubscriptionRefresh;

  constructor(private broadcastingsService: BroadcastingsService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getBroadcastingsConfig();
    this.refreshConfigSubscriptionRefresh = this.broadcastingsService.refreshConfigListen().subscribe(
      (res) => {
        this.getBroadcastingsConfig();
      }
    );
  }

  private getBroadcastingsConfig() {
    this.getBroadcastingsConfigSubscription = this.broadcastingsService.getBroadcastingsConfig().pipe(
      tap(o => this.config = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb(
      'fas fa-cogs',
      'broadcastings-page.config',
      '/broadcastings',
      [
        new BRoute('broadcastings-page.broadcastings', '/broadcastings'),
        new BRoute('broadcastings-page.config')
      ]
    ));
  }

  ngOnDestroy() {
    if (this.refreshConfigSubscriptionRefresh) { this.refreshConfigSubscriptionRefresh.unsubscribe(); }
  }

}
